export default __webpack_public_path__ + "static/media/toplogo.5a17e58f.png";